import Vue from 'vue'
import Vuex from 'vuex'

import projects from './projects-data';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      projects: projects,
      config:{
        aspectratio: 3.2
      }
  },
  mutations: {

  },
  actions: {

  }
})
